<template>
  <div>
    <div class="classified_confirmation">
      <p class="aligncenter">Le produit a bien été ajouté à votre panier</p>
      <p class="aligncenter">
        <span>
          <svg width="24" height="24">
            <use xlink:href="#icon-shopping-cart"></use>
          </svg>
        </span>
      </p>
    </div>
    <!-- .classified_confirmation -->
    <div class="pa-footer pa-footer--basket">
      <div class="bt bt-prev">
        <button
          type="submit"
          aria-label="Continuer mes achats"
          @click="goToStep1()"
        >
          <span>Continuer mes achats</span>
        </button>
      </div>
      <div class="bt bt-submit">
        <button
          type="button"
          name="cart"
          @click="goToBasket"
          aria-label="Accéder à mon panier"
        >
          <span>Accéder à mon panier</span>
          <svg width="12" height="12">
            <use xlink:href="#icon-arrow"></use>
          </svg>
        </button>
      </div>
    </div>
    <!-- .pa-footer -->
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from "vuex";
export default {
  name: "classified-resume",
  components: {},
  mounted() {
    this.$scrollTo("#main"); //, 300, { easing: "ease" });
  },
  computed: {
    ...mapState(["classified"]),
    ...mapGetters(["getSettings"]),
  },
  methods: {
    // ...mapMutations(["setStep"]),
    goToBasket() {
      this.setStep(1);
      window.location = "/panier/";
    },
    goToStep1() {
      this.setStep("1");
    },
  },
};
</script>

<style lang="scss" scoped>
label {
  display: block;
}
</style>
